/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { analyticsControllerTrackEvent } from '../fn/analytics/analytics-controller-track-event';
import { AnalyticsControllerTrackEvent$Params } from '../fn/analytics/analytics-controller-track-event';

@Injectable({ providedIn: 'root' })
export class AnalyticsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `analyticsControllerTrackEvent()` */
  static readonly AnalyticsControllerTrackEventPath = '/analytics/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analyticsControllerTrackEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  analyticsControllerTrackEvent$Response(params: AnalyticsControllerTrackEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return analyticsControllerTrackEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analyticsControllerTrackEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  analyticsControllerTrackEvent(params: AnalyticsControllerTrackEvent$Params, context?: HttpContext): Observable<void> {
    return this.analyticsControllerTrackEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
